import { fechaLarga } from '../../../compartido/formato';
import type { Fecha } from '../../../compartido/tipos';
import { grillaDelMes, tituloMes } from '../lib/fechas';
import { FlechaDer, FlechaIzq } from './Iconos';

const CABECERA = ['L', 'M', 'M', 'J', 'V', 'S', 'D'];
const CABECERA_LARGA = ['lunes', 'martes', 'miércoles', 'jueves', 'viernes', 'sábado', 'domingo'];

export type EstadoDia = 'libre' | 'lleno' | 'no';

/**
 * Calendario de un mes. No sabe de reservas: recibe qué días están libres,
 * cuáles llenos (había horario pero ya no queda nada) y cuáles no aplican
 * (pasado, domingo, fuera de la ventana).
 */
export function Calendario({
  mes,
  estado,
  elegido,
  hoy,
  onElegir,
  onMes,
  puedeAtras,
  puedeAdelante,
  cargando,
}: {
  mes: string;
  estado: (f: Fecha) => EstadoDia;
  elegido: Fecha | undefined;
  hoy: Fecha;
  onElegir: (f: Fecha) => void;
  onMes: (delta: number) => void;
  puedeAtras: boolean;
  puedeAdelante: boolean;
  cargando: boolean;
}) {
  return (
    <div className="calendario">
      <div className="calendario__mes">
        <button type="button" className="calendario__flecha" aria-label="Mes anterior" disabled={!puedeAtras} onClick={() => onMes(-1)}>
          <FlechaIzq />
        </button>
        <h2 className="calendario__nombre" aria-live="polite">
          {tituloMes(mes)}
        </h2>
        <button type="button" className="calendario__flecha" aria-label="Mes siguiente" disabled={!puedeAdelante} onClick={() => onMes(1)}>
          <FlechaDer />
        </button>
      </div>

      <div className="calendario__grilla" aria-hidden="true">
        {CABECERA.map((d, i) => (
          <div key={i} className="calendario__cabeza" title={CABECERA_LARGA[i]}>
            {d}
          </div>
        ))}
      </div>
      <div className="calendario__grilla" role="group" aria-label={`Días de ${tituloMes(mes)}`} aria-busy={cargando}>
        {grillaDelMes(mes).map((f, i) => {
          if (!f) return <span key={`v${i}`} aria-hidden="true" />;
          const e = cargando ? 'no' : estado(f);
          const clase = [
            'dia',
            e === 'libre' && 'dia--libre',
            e === 'lleno' && 'dia--lleno',
            f === elegido && 'dia--elegido',
            f === hoy && 'dia--hoy',
          ]
            .filter(Boolean)
            .join(' ');
          const etiqueta = `${fechaLarga(f)}${e === 'lleno' ? ', sin horas libres' : e === 'no' ? ', no disponible' : ''}`;
          return (
            <button
              key={f}
              type="button"
              className={clase}
              disabled={e !== 'libre'}
              aria-pressed={f === elegido}
              aria-label={etiqueta}
              onClick={() => onElegir(f)}
            >
              {Number(f.slice(8))}
            </button>
          );
        })}
      </div>

      <div className="leyenda" aria-hidden="true">
        <span>
          <span className="punto" style={{ background: '#fff', border: '1px solid #D5C8B7' }} />
          Libre
        </span>
        <span>
          <span className="punto" style={{ background: '#85682E' }} />
          Elegido
        </span>
        <span>
          <span className="punto" style={{ background: '#E0D6C8' }} />
          Sin horas libres
        </span>
      </div>
    </div>
  );
}
